export default __webpack_public_path__ + "2fc2741ef7c800573f85b6c076b4407f.jpeg";